// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {url2md5} from 'pub_config';
import cn from 'classnames';

interface i_flag_props {
    country: string;
    cls?: string;
    size?: number;
    round?: boolean;
    on_click?: ()=>void;
}
export const Flag = (props: i_flag_props)=>{
    const {country, cls, size = 48, round = false, on_click} = props;
    const path = round ? 'flags/round' : 'flag/svg_4x3';
    return <img className={cn(cls, 'lazyload')} onClick={on_click} width={size}
      alt={`${country}`} height={size}
      src={url2md5(`/www/hola/pub/img/${path}/${country}.svg`)}/>;
};
